import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { path } from 'ramda';

import styles from './styles.m.scss';

import mentorConnectImg from '../../../../images/mentor-connect-vignette.png';
import membershipVideo from '../../../../images/membership-video.jpg';

import { routes } from '../../../routes';
import magic from '../../../util/magic';

import Card from '../../../components/Card';
import MembershipStatus from '../../../components/MembershipStatus';
import Video from '../../../components/Video';
import Announcements from '../../../components/Announcements';
import Resource from '../../../components/Resource';

const mapState = ({ membershipResources, announcements, user }) => ({
  membershipResources,
  announcements,
  user,
});

class Dashboard extends Component {
  static propTypes = {
    announcements: PropTypes.array,
    membershipResources: PropTypes.array,
    user: PropTypes.object,
  };

  render() {
    const { announcements, membershipResources, user } = this.props;
    const isMember = path(['membership', 'valid'], user);

    return (
      <div className="row">
        <div className="col-md-8">
          {isMember && (
            <Announcements
              className="mb-4"
              announcements={announcements.filter((a) => a.type == magic.membershipAnnouncement)}
            />
          )}
          <MembershipStatus user={user} />
          <a
            href="https://www.instagram.com/explore/tags/Sage Financial Solutions/"
            target="_blank"
            className="font-weight-bold d-inline-block mb-2"
          >
            #Sage Financial Solutions
          </a>
          <ul className="juicer-feed" data-feed-id="afcpe" data-per="4" data-truncate="75" />
          {isMember && (
            <div id="membership-resources">
              <Card membership className="mb-4">
                <Card.Header>Membership Resources</Card.Header>
                <Card.Body className="d-flex flex-wrap">
                  {membershipResources.map((resource) => (
                    <Resource key={resource.id} resource={resource} />
                  ))}
                </Card.Body>
              </Card>
            </div>
          )}
        </div>
        <div className="col-md-4">
          <Video className="mb-4" image={membershipVideo} title="The Value of Sage Financial Solutions Membership" youtube="oU5GCNbO-jA" />
          {isMember && (
            <Card membership className="mb-4">
              <Card.Header>MentorConnect</Card.Header>
              <Card.Body>
                <img src={mentorConnectImg} className={styles.mentorConnectImg} />
                <p className="mt-3">
                  At Sage Financial Solutions
                  <sup>&reg;</sup>, we believe in the value of connection and the importance of relationship building,
                  which is why we are passionate about connecting financial professionals across the continuum of care.
                </p>
                <a href={routes.wordPress.mentorConnect} className="btn btn-outline-primary">
                  Join MentorConnect
                </a>
              </Card.Body>
            </Card>
          )}
        </div>
      </div>
    );
  }
}

export default connect(mapState)(Dashboard);
